<template>
  <div class="subModal">
    <form @submit="setTic">
      <input type="text" placeholder="Assunto" v-model="assunto">
      <textarea name="text" placeholder="Digite..." v-model="text"></textarea>
      <button>Enviar</button>
    </form>
  </div>
</template>

<script setup>


import { ref } from 'vue'

const emits = defineEmits(['textAlerta'])

const assunto = ref('')
const text = ref('')

async function setTic(e) {
  e.preventDefault()
  if (!assunto.value.trim() || !text.value.trim()) {
    emits('textAlerta', 'Preencha assunto e mensagem')
    return
  }
  try {
    const res = await fetch('/api/records/tickets', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ subject: assunto.value.trim(), message: text.value.trim() }),
    })
    if (!res.ok) throw new Error('ticket')
    assunto.value = ''
    text.value = ''
    emits('textAlerta', 'Ticket enviado!')
  } catch (_) {
    emits('textAlerta', 'Erro ao enviar ticket')
  }
}

</script>

<style scoped>

.subModal textarea {
  max-height: 136px;
}
</style>
